module.exports = __webpack_public_path__ + "img/block-city.3dc3baee.png";